import * as React from 'react';

interface Props {
  className?: string;
}

export const FormGroup: React.FC<React.PropsWithChildren<Props>> = ({ className = '', children }) => {
  return <div className={`${className} mb-6`}>{children}</div>;
};
